module.exports = __webpack_public_path__ + "static/media/avast-vince-tiger.42fa2718.jpg";